/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

interface IGiftCardTitleProps {
    title: string;
}

const GiftCardTitle: React.FC<IGiftCardTitleProps> = ({ title }) => <label className='ms-checkout-gift-card__title'>{title}</label>;

export default GiftCardTitle;
